import { render } from "./KeypointSwitch.vue?vue&type=template&id=9348fd54"
import script from "./KeypointSwitch.vue?vue&type=script&lang=js"
export * from "./KeypointSwitch.vue?vue&type=script&lang=js"

import "./KeypointSwitch.vue?vue&type=style&index=0&id=9348fd54&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__